import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ConversationService } from '../services/conversation.service';
import { Router } from '@angular/router';
import { SpeechRecognitionService } from '../services/speech-recognition.service';
import { LoadingSummaryService } from '../services/loading-summary.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css']
})
export class SearchbarComponent implements OnInit, OnDestroy {
  
  @Input() profileView: boolean = false;
  @Input() isCard:boolean = false;
  @Input() isCatalogue: boolean;
  @Input() hidden: boolean = false;
  @Input() enableSearch: boolean = false;
  @Input() set keyword(word:string){
    if (word != "#trigger"){
      this.setKeyword = word;
    }
  }
  @Input() set setPlaceholder(text: string){
    if (text){
      this.placeholder = text.toLowerCase();
    } 
  }
  @Input() set summaryRefreshed(bool:boolean){
    if (this.isBusy){
      this.isBusy = false;
    }
  }

  @Output() keywordChanged = new EventEmitter<string>();

  @ViewChild('searchTextbox') searchTextbox:string;

  isBusy:boolean = false;
  speechApi: boolean = true;
  speechData: string;
  selectedValue = 'Current';
  currentKeyword:string;
  valueSelection:any;
  setKeyword: string = '';
  placeholder: string;
  sub: Subscription;

  constructor(private conversationService: ConversationService, private router: Router, private speechRecognitionService:SpeechRecognitionService, private changeDetector: ChangeDetectorRef, private loadingSummaryService:LoadingSummaryService) { 
    this.sub = loadingSummaryService.loadingSummaryChanged$.subscribe(value => {
      if (this.isBusy && !value){
        this.isBusy = false;
      }
    });
  }

  ngOnInit() {
    this.valueSelection = [];
    this.valueSelection.push({ItemValue: "Current", ItemDisplay: "Current View"});
    this.valueSelection.push({ItemValue: "Global", ItemDisplay: "Global View"});
  }

  ngOnDestroy(){
    if (this.sub) this.sub.unsubscribe();
  }

  ngAfterViewChecked(){
    this.changeDetector.detectChanges();
  }

  searchByKeyword(keyword:string){
    this.isBusy = true;
    this.loadingSummaryService.setLoading(true);
    if (this.setKeyword == keyword){
      this.keywordChanged.emit("#trigger");
    }
    this.setKeyword = keyword;
    setTimeout(() => {
      this.keywordChanged.emit(keyword);
    })
  }

  changeView(view){
    // console.log(view);
    // this.selectedValue = view;
  }

  searchGlobal(text: string) {
    this.isBusy = true;
    this.conversationService.converse(text).subscribe(result=> {
      this.isBusy = false;
      var resultObject = JSON.parse(result);
        if(resultObject.ReturnType == "0"){
          if(resultObject.Arguments){
            var path = [];
            resultObject.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
        }
    });
  }

  activateSpeech(): void {
  //this.showSearchButton = false;

  this.speechRecognitionService.record()
      .subscribe(
      //listener
      (value) => {
          this.speechData = value;
          console.log(value);
      },
      //error
      (err) => {
          console.log(err);
          if (err.error == "no-speech") {
              console.log("--restarting service--");
              this.activateSpeech();
          }
      },
      //completion
      () => {
          //this.showSearchButton = true;
          console.log("--complete--");
          //this.activateSpeech();            
          this.searchGlobal(this.speechData);
      });
  }

}